// tslint:disable:max-line-length

import React from 'react';

export const ActionFavorite = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8 0l-2 6h-6l5 4-2 6 5-4 5 4-2-6 5-4h-6l-2-6z" />
    </svg>
  );
};
